/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const StarHalfFilledIcon = /*#__PURE__*/ createSvgIcon(
  'StarHalfFilledIcon',
  {
    ltr: {
      large: ({ id }) => (
        <>
          <path
            d="M10 5.792v6.52l2.688 1.584-.709-3 2.313-1.98-3.063-.27L10 5.792zm0 8.27l-3.417 2.042a.747.747 0 01-.833-.042.752.752 0 01-.25-.343.706.706 0 01-.02-.448l.895-3.813-3.02-2.562a.68.68 0 01-.23-.386.887.887 0 01.02-.427.687.687 0 01.23-.343.741.741 0 01.417-.157L7.75 7.23l1.563-3.625A.754.754 0 0110 3.146a.747.747 0 01.688.458L12.25 7.25l3.958.333c.167.014.306.07.417.167a.771.771 0 01.24.77.74.74 0 01-.24.376l-3 2.562.896 3.813a.706.706 0 01-.02.448.752.752 0 01-.25.344.747.747 0 01-.834.041L10 14.063z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
  true
);

export default StarHalfFilledIcon;
